import { render, staticRenderFns } from "./ProcAdd.vue?vue&type=template&id=090788e0&scoped=true&"
import script from "./ProcAdd.vue?vue&type=script&lang=js&"
export * from "./ProcAdd.vue?vue&type=script&lang=js&"
import style0 from "./ProcAdd.vue?vue&type=style&index=0&id=090788e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "090788e0",
  null
  
)

export default component.exports